import { memo, useEffect } from 'react';

import auth from 'app/core/auth';

interface Props {}

export default memo((props: Props) => {
  useEffect(() => {
    const fetchData = async () => {
      const mgr = auth.userManager;
      mgr.signinSilentCallback().catch((err) => {
        console.log(err, 'error silent redirect call back');
      });
    };
    fetchData();
  }, []);

  return <></>;
});
